import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

function Semantic(props) {

  const {language, setLanguage, spelling, setSpelling, top, setTop} = props;

  return (
    <Form>
      <Row className="align-items-center g-3">
        {/* DropDown */}
        <Col style={{padding: '0px', marginBottom: '6px', marginRight: '5px', marginTop: '10px'}}>
          <Form.Label>Language</Form.Label>
          <Form.Select
            size="sm"
            style={{ width: '110px' }}
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="eng">English</option>
            <option value="rus">Русский</option>
          </Form.Select>
        </Col>

        {/* Number input */}
        <Col style={{padding: '0px', marginBottom: '6px', marginTop: '10px'}}>
          <Form.Label>Top</Form.Label>
          <Form.Control
            type="number"
            size="sm"
            style={{ width: '70px' }}
            value={top}
            onChange={(e) => setTop(parseInt(e.target.value, 10))}
            min={1}
            max={50}
          />
        </Col>

        {/* Checkbox */}
        <Col style={{padding: '0px'}}>
          <Form.Check
            type="checkbox"
            style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.85rem', marginTop: '7px' }}
            className="form-check-sm"
            label="Spelling"
            checked={spelling}
            onChange={(e) => setSpelling(e.target.checked)}
          />
        </Col>

      </Row>
    </Form>
  );
}

export default Semantic;